import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp } from "../lib/motion";

const EMAIL = "hello@chadowmarketing.com";
const MAILTO = `mailto:${EMAIL}?subject=Application%20—%20Chadow%20Marketing&body=Tell%20us%20about%20your%20audience%2C%20current%20offers%2C%20and%20where%20the%20backend%20is%20weakest.`;

export const Apply = () => {
  return (
    <section
      id="apply"
      data-testid="apply-section"
      className="relative py-24 md:py-32 lg:py-48 px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto text-center overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 40%, rgba(201,162,107,0.08), transparent 55%)",
        }}
      />

      <motion.div {...fadeUp} className="relative flex items-center justify-center gap-3 mb-8">
        <span className="block w-12 h-px bg-[#C9A26B]" />
        <span className="eyebrow">09 — Apply</span>
        <span className="block w-12 h-px bg-[#C9A26B]" />
      </motion.div>

      <motion.h2
        {...fadeUp}
        className="relative font-display text-4xl sm:text-6xl lg:text-7xl xl:text-[88px] leading-[1.02] tracking-tight max-w-[18ch] mx-auto"
      >
        If the audience is there, the backend{" "}
        <span className="italic text-[#C9A26B]">should be too.</span>
      </motion.h2>

      <motion.p
        {...fadeUp}
        className="relative mt-10 max-w-2xl mx-auto text-[#A8A39D] text-base md:text-lg leading-relaxed"
      >
        If your creator business has traction but the monetization systems
        behind it are still underbuilt, there is likely more revenue and
        leverage sitting inside what you&rsquo;ve already built. Chadow Marketing
        turns that into structure.
      </motion.p>

      <motion.div
        {...fadeUp}
        className="relative mt-14 flex flex-col items-center gap-6"
      >
        <a
          href={MAILTO}
          data-testid="apply-mailto-btn"
          className="group inline-flex items-center gap-4 px-10 py-5 bg-[#C9A26B] text-[#0D0E12] hover:bg-[#E5BE87] transition-colors duration-300 text-[12px] tracking-[0.24em] uppercase"
        >
          Apply for Chadow Marketing
          <ArrowUpRight
            size={18}
            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </a>

        <a
          href={MAILTO}
          data-testid="apply-email-link"
          className="text-[#A8A39D] text-sm tracking-wide hover:text-[#F4EFE6] transition-colors"
        >
          {EMAIL}
        </a>

        <p className="mt-2 text-xs text-[#A8A39D]/80 tracking-wide max-w-md">
          Selective engagements for creators with traction, demand, and serious
          intent.
        </p>
      </motion.div>
    </section>
  );
};

export default Apply;
